/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSouscriptionSupportingDocumentsQuery from '../graphql/queries/GetSouscriptionSupportingDocumentsQuery.js';

const useGetSouscriptionSupportingDocumentsQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSouscriptionSupportingDocumentsQuery, args);

  return {
    error,
    loading,
    refetch,
    getSouscriptionSupportingDocuments: R.omit(['__typename'], data?.getSouscriptionSupportingDocuments_souscription_supporting_documents || {})
  };
};

export default useGetSouscriptionSupportingDocumentsQuery;
